function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3311.808 -1365.472)",
  opacity: 0.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M5689.743,3158.161c-28.821,0-73.212,23.355-99.146,52.161L3423.974,5636.756h208.7l2213.593-2478.6Z",
  transform: "translate(31.51 503.612)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5922.284,3158.154c-14.413,0-36.623,11.688-49.6,26.1L3710.575,5636.757H3867.1l2185.6-2478.6Z",
  transform: "translate(112.024 503.61)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6278.469,3105.193H6174.142l-.009-.009L3943.207,5651.639h104.342Z",
  transform: "translate(177.376 488.729)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3888.855,2003.835C3914.8,2032.639,3959.2,2056,3988,2056h208.709L3572.5,1365.472H3311.808Z",
  transform: "translate(0 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5532.812,3479.158c25.952,28.821,70.337,52.181,99.143,52.181h156.531L3838.33,1365.472H3629.643Z",
  transform: "translate(89.288 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5821.053,3505.254c12.959,14.4,35.174,26.083,49.586,26.083h130.42L4050.909,1365.472H3894.39Z",
  transform: "translate(163.662 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4223.209,1365.973c-.155-.174-.344-.332-.5-.5H4118.417l2006.5,2228.439h104.337Z",
  transform: "translate(226.596 0)",
  fill: "#fff"
}));

function SvgDecorationLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3144.037,
    height: 4774.896,
    viewBox: "0 0 3144.037 4774.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorationLight);
export default __webpack_public_path__ + "static/media/decoration-light.abcc8c0a205f6f29224e3460af0d2598.svg";
export { ForwardRef as ReactComponent };